<template>
  <v-dialog :value="value" persistent @input="input => $emit('input', input)" width="600">
    <v-card class="pa-3 pb-10">
      <v-card-title>
        <div class="d-flex flex-column">
          <span>UTM Builder</span>
          <span class="caption">Link: {{name}}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <div class="pl-5 pr-5 pt-5">
        <v-row>
          <v-col cols="6">
            <v-text-field
              persistent-hint
              dense
              outlined
              label="Origem da campanha"
              v-model="utms.source"
              hint="A origem. Ex: Facebook, Google, Instagram"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              persistent-hint
              dense
              outlined
              label="Meio da campanha"
              v-model="utms.medium"
              hint="Ex.: banner, email, cpc"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              dense
              persistent-hint
              outlined
              label="Nome da campanha"
              v-model="utms.campaign"
              hint="Ex: produto, slogan"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              persistent-hint
              dense
              outlined
              label="ID da campanha (Opcional)"
              v-model="utms.id"
              hint="O ID do Ads da campanha"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              persistent-hint
              dense
              outlined
              label="Termo de campanha (Opcional)"
              v-model="utms.term"
              hint="Utilize para identificar palavras pagas"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              dense
              persistent-hint
              outlined
              label="Conteúdo do Ads (Opcional)"
              v-model="utms.content"
              hint="Utilize para diferenciar os ads"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="URL final"
              dense
              :disabled="!isValid"
              :value="!isValid ? 'Preencha as UTMs obrigatórias (Origem, meio e nome da campanha)' : link"
              outlined
              readonly
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <v-btn class="mt-5" :disabled="!isValid" block depressed color="#803BE8" :dark="isValid" @click="copy()">
          <v-icon class="mr-1" small>mdi-content-copy</v-icon>
          Copiar link com UTMs
        </v-btn>
      </div>
    </v-card>

    <v-snackbar v-model="copied" :timeout="2000">
      Link copiado para área de transferência
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" small text v-bind="attrs" @click="copied = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import qs from 'qs'

export default {
  props: ['value', 'url', 'name'],
  data () {
    return {
      copied: false,
      utms: {
        id: '',
        source: '',
        medium: '',
        campaign: '',
        content: '',
        term: ''
      }
    }
  },
  computed: {
    isValid () {
      return !!(this.utms.source && this.utms.medium && this.utms.campaign)
    },
    link () {
      const query = {}

      if (this.utms.id) {
        query.utm_id = this.escapeSpace(this.utms.id)
      }

      if (this.utms.source) {
        query.utm_source = this.escapeSpace(this.utms.source)
      }

      if (this.utms.medium) {
        query.utm_medium = this.escapeSpace(this.utms.medium)
      }

      if (this.utms.campaign) {
        query.utm_campaign = this.escapeSpace(this.utms.campaign)
      }

      if (this.utms.term) {
        query.utm_term = this.escapeSpace(this.utms.term)
      }

      if (this.utms.content) {
        query.utm_content = this.escapeSpace(this.utms.content)
      }

      return `${this.url}?${qs.stringify(query)}`
    }
  },
  methods: {
    escapeSpace (str) {
      return (str || '').replace(/\s/g, '_')
    },
    copy () {
      console.log(this.link)
      const el = document.createElement('textarea')
      el.value = this.link
      el.setAttribute('readonly', '')
      el.style = { position: 'absolute', left: '-9999px' }
      document.body.appendChild(el)
      el.select()
      el.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(el.value)
      document.body.removeChild(el)
      this.copied = true
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-color {
  height: 45px;
  width: 45px;
  border-radius: 5px;
  background-color: black;
  position: relative;
  top: -12px;
  cursor: pointer;
}
</style>
